import { request } from '@/shared/api/request'

export const sendEditWorkPlaceEsutd = ({data, params}) => {
	return request({ url: 'staff/edit/send', method: 'POST', data: data, params })
}
